import Vue from 'vue'
import {i18n} from '@js/i18n'
import store from '@vuex'
import {mapGetters} from 'vuex'
import {vuexTypes} from '@vuex/types'
import FlowBlockingModalMixin from './flow-blocking-modal.mixin'

import {commonEvents} from '@js/events/common_events'
import {EventDispatcher} from '@js/events/event_dispatcher'
import {dispatchAppEvent} from '@js/events/helpers'
import {ErrorFactory, errors} from '@js/errors/factory'
import { factorsService } from '@api/factors.service'

import {createTfaRecoveryDialog} from './tfa_recovery.modal'

const template = `
   <md-dialog :md-fullscreen="false" :md-active.sync="isOpened">
     <md-dialog-title>{{ i18n.mod_tfa_required() }}</md-dialog-title>
  
     <form novalidate @submit.prevent="onSubmit">
       <div class="app__dialog-inner">
         <input-field v-model="form.code"
                      v-validate="validations.code"
                      id="modal-tfa-code"
                      name="code"
                      :autofocus="true"
                      :errorMessage="errorMessage('code')"
                      :label="i18n.lbl_tfa_code()"
         />
       </div>
  
       <md-dialog-actions>
         <md-button class="md-primary" @click="close">{{ i18n.lbl_cancel() }}</md-button>
         <md-button class="md-primary" type="submit" :disabled="isPending">{{ i18n.lbl_submit() }}</md-button>
       </md-dialog-actions>
      
       <md-dialog-actions class="md-layout md-alignment-center-left">
         <md-button class="md-primary" @click="recoverTfa">{{ i18n.lbl_lost_2fa() }}</md-button>
       </md-dialog-actions>
     </form>
   </md-dialog>
 `

export function createTfaDialog (callback, {factorId, token, walletId, repeatDetails}, isCrutch = false) {
  const tfaModal = document.createElement('div')
  document.querySelector('#app').appendChild(tfaModal)

  return new Promise((resolve, reject) => {
    const TFADialog = new Vue({
      template,
      store,
      mixins: [FlowBlockingModalMixin],
      data: _ => ({
        form: {
          code: ''
        },
        validations: {
          code: 'required'
        }
      }),
      created () {
        this.setResolvers(resolve, reject)
      },
      computed: {
        ...mapGetters([
          vuexTypes.isLoggedIn
        ])
      },
      methods: {
        async onSubmit () {
          if (!await this.isValid()) return
          this.disable()
          if (!isCrutch) {
            try {
              await factorsService.verifyFactor(factorId, token, this.form.code, walletId)
            } catch (error) {
              if (error instanceof errors.TFAWrongCodeError) {
                EventDispatcher.dispatchShowErrorEvent(i18n.tfa_wrong_code())
                this.enable()
                return
              } else if (error instanceof errors.TFAExceededCodeError) {
                EventDispatcher.dispatchShowErrorEvent(i18n.tfa_to_many_attempts())
                this.close()
                this.enable()
                return
              } else {
                return this.resolvers.reject(error)
              }
            }

            this.resetResolvers()
            this.removeElement()

            try {
              await this.resolvers.resolve(await callback())
            } catch (error) {
              return this.resolvers.reject(error)
            }

            this.enable()
          } else {
            const params = {token: this.form.code}
            try {
              await callback(params)
            } catch (error) {
              if (error instanceof errors.TFAWrongCodeError) {
                EventDispatcher.dispatchShowErrorEvent(i18n.tfa_wrong_code())
                this.enable()
                return
              } else if (error instanceof errors.TFAExceededCodeError) {
                EventDispatcher.dispatchShowErrorEvent(i18n.tfa_to_many_attempts())
                this.close()
                this.enable()
                return
              } else {
                return this.resolvers.reject(error)
              }
            }
            this.resetResolvers()
            this.removeElement()
            this.enable()
          }
        },
        async recoverTfa () {
          this.isHide = true
          this.isOpened = false

          if (this.isLoggedIn) {
            dispatchAppEvent(commonEvents.showTfaRecovery)
            EventDispatcher.dispatchShowSuccessEvent(i18n.tfa_recovery_blocked())
          } else {
            try {
              await factorsService.lostFactor(walletId)
              EventDispatcher.dispatchShowSuccessEvent(i18n.tfa_recovery_blocked())
              await createTfaRecoveryDialog(null, {walletId})
            } catch (error) {
              return this.resolvers.reject(error)
            }

            try {
              await this.resolvers.resolve(await callback())
            } catch (error) {
              return this.resolvers.reject(error)
            }
          }
        }
      },
      // TODO: this watcher doesn't work if placed in mixin, resolve why and remove code duplication from here and
      // tfa modal
      watch: {
        isOpened (val) {
          if (!val) {
            if (!this.isResolved && !this.isHide) {
              this.resolvers.reject(ErrorFactory.getOTPCancelledError())
            }
            this.removeElement()
          }
        }
      }
    })
    TFADialog.$mount(tfaModal)
  })
}



// WEBPACK FOOTER //
// ./src/js/modals/tfa_dalog.modal.js